import { render, staticRenderFns } from "./ContactSuwonPage.vue?vue&type=template&id=3b152efc&scoped=true"
import script from "./ContactSuwonPage.vue?vue&type=script&lang=js"
export * from "./ContactSuwonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b152efc",
  null
  
)

export default component.exports